<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { TabsRoot, useForwardPropsEmits } from 'radix-vue'
import type { TabsRootEmits, TabsRootProps } from 'radix-vue'
import useQueryParams from '../../../useQueryParams'

const props = defineProps<
  TabsRootProps & {
    dropQueryParams?: boolean
    urlKey?: string
  }
>()
const emits = defineEmits<TabsRootEmits>()

let params: ReturnType<typeof useQueryParams> | undefined
if (!props.dropQueryParams)
  params = useQueryParams(
    { tab: props.defaultValue },
    { tab: 't' },
    {
      key: props.urlKey,
    }
  )

const { dropQueryParams, urlKey, ...omittedProps } = props

const forwarded = useForwardPropsEmits(
  {
    ...omittedProps,
    defaultValue: (params?.state.value.tab as string) ?? props.defaultValue,
  },
  (evt: 'update:modelValue', payload: string) => {
    if (!props.dropQueryParams) params.updateParams({ tab: payload })

    emits('update:modelValue', payload)
  }
)
</script>

<template>
  <TabsRoot v-bind="forwarded">
    <slot />
  </TabsRoot>
</template>
